// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"680e27c3","475":"362f0dcc","563":"0501dd7b","705":"9559b063","744":"86e4a97e","756":"54c9078e","950":"b6ed68c4","952":"2a7bbdad"}[chunkId] + ".chunk.js";
};